import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContextProvider } from "./context/toastContext";
import App from "./App";

import "./index.css";
import "react-photo-view/dist/react-photo-view.css";
import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";

// Allow future ChunkLoadError recovery after a successful boot.
sessionStorage.removeItem("str_chunk_load_reload");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter
    future={{
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    }}
  >
    <ToastContextProvider>
      <App />
    </ToastContextProvider>
  </BrowserRouter>
);
